import RouterGuard from './_RouterGuards'
import store from '../store'
import RankingsIndex from '../components/organizations/rankings/RankingsIndex'
import OrganizationSearchV2 from '../components/organizations/search/OrganizationSearch'
import EmbeddedReports from '../components/organizations/reports/EmbeddedReports'

export default {
  organizationRankings: {
    path: '/organizations/ranking',
    name: 'Organization Rankings',
    component: RankingsIndex,
    beforeEnter: function (to, from, next) {
      return RouterGuard.isAccountType(to, from, next, store.getters.hasMAAStaff)
    }
  },
  organizationsSearch: {
    path: '/organizations/search',
    name: 'Organization Search Tool',
    component: OrganizationSearchV2,
    beforeEnter: function (to, from, next) {
      return RouterGuard.isAccountType(to, from, next, store.getters.hasMAAStaff)
    }
  },
  embeddedReports: {
    path: '/organizations/reports',
    name: 'Embedded Reports',
    component: EmbeddedReports,
    beforeEnter: function (to, from, next) {
      return RouterGuard.isAccountType(to, from, next, store.getters.hasMAAStaff)
    }
  }
}



// WEBPACK FOOTER //
// ./src/router/organizations.js